import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import FontAwesomeIcon from '../FontAwesomeIcon/FontAwesomeIcon';
import Tooltip from '../Tooltip/Tooltip';
import styles from './Checkbox.module.sass';

export enum CHECKBOX_STATE {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    DISABLED = 'disabled',
    SELECTED = 'selected'
}

const Checkbox = ({
    label,
    onClick,
    state: rawState
}: Props) => {
    const [state, setState] = useState(rawState || CHECKBOX_STATE.INACTIVE);
    
    const handleClick = (e: any) => {
        e.stopPropagation();
        onClick();
    };

    useEffect(() => {
        setState(rawState);
    }, [rawState]);

    return <div className={styles['checkbox']} onClick={(e) => handleClick(e)}>
        <div className={`${styles['checkbox__icon']} ${styles['checkbox__icon--' + state]}`}>
            { state === 'active' && <FontAwesomeIcon icon={faCheck} /> }
        </div>
        <div
            className={styles['checkbox__label']}
        >
            { label }
        </div>
    </div>;
}

interface Props {
    label: any,
    onClick: any,
    state: 'active' | 'inactive' | 'disabled' | 'selected'
}

export default React.memo(Checkbox);